let onglet = {
    init() {

        $('.onglet-title li').click(function () {
            let id = $(this).attr('id');

            $('.onglet-title li').removeClass('active');
            $(this).addClass('active');

            $('.onglet-content .onglet').fadeOut(300);
            $('.onglet-content .' + id).delay(300).fadeIn(300);
        });

        this.initFromQuery();
    },
    initFromQuery() {
        if ($('body').hasClass('page-node-type-document-pro')) {
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('type')) {
                let type = urlParams.get('type');
                $('.onglet-title li.js-' + type).trigger('click');
            } else {
                $('.onglet-title li').first().trigger('click');
            }
        }
    }
}

export default onglet;
